<template>
  <router-link tag="div" :to="{name:'subject',params: {slug: subject.slug}}"
               class="card border-0 shadow d-flex flex-column py-4 align-items-center cursor-pointer subject-view-v2">
    <img :src="subject.logo" class="wh100x" :alt="'icon ' + subject.name">
    <span class="title">{{subject.name}}</span>
    <small class="text-green">Coef {{subject.coef}}</small>
  </router-link>
</template>

<script>
  export default {
    name: 'SubjectV2',
    props: {subject: {type: Object}}
  }
</script>

<style lang="scss">
</style>
